import React, { Component } from "react";
import { invokeApig } from "../libs/awsLib";
import { Menu, Header, Grid, Input, Modal, Label, Table, Segment, List, Button, Icon, Dropdown, Message, Popup, Form, Pagination, Tab, Divider, Dimmer, Loader} from 'semantic-ui-react'
import './Messages.css';
import DataFlowViewer from "./DataFlowViewer"
import MessageResponseModal from "./MessageResponseModal"
import UserSearch from "./UserSearch"
import Comments from "./Comments"
import { formatDateTime, exportToExcel } from "../libs/sharedFunctions";
import { Link } from "react-router-dom";
import MessageHistory from "./MessageHistory";
import FunctionModal from "./FunctionModal";
import SubscriptionModal from "./SubscriptionModal";
import ReactJson from 'react-json-view'

const PAGE_SIZE=10;

export default class Messages extends Component {
  constructor(props) {
    super(props);
    this.loadMessageQueues=this.loadMessageQueues.bind(this)
    this.loadMessages=this.loadMessages.bind(this)
    this.postResponse=this.postResponse.bind(this)
    this.closeResponseModal = this.closeResponseModal.bind(this)
    this.closeHoldModal = this.closeHoldModal.bind(this)
    this.closeSubscriptionModal = this.closeSubscriptionModal.bind(this)
    //this.filterQueues = this.filterQueues.bind(this)
  this.state={messagequeuecategories: [], selectedCategory: {id: 17,messagequeues:[]}, selectedMessage: {id: null, header: [], detail: []}, selectedqueueid: null, selectedQueue: {name: ''}, messages:[], columnHeaders: [], responses: [], messageQueuesLoaded: false, queueSearch: '', queueCounts: {}, categoryCounts: {}, messageSelected: false, validationMessages:[], validationFailed: false, showResponseModal: false, selectedResponse: {'fields':[], 'pages': []}, dataflowvisible: false, users: [], showAssignUser: false, assignUserId: null, assignedFilter: 'All', messagePage: 1, allqueues: [], assignedToMeFilter: false, showHoldModal: false, holdButton: false, statusColumnId: null, heldFilter: 0, heldFilterData: [{sqlFilter:'all', icon:'envelope', text:'Click to show workable messages', nextKey:1} ,{sqlFilter:'workable', icon:'play', text:'Click to show held messages', nextKey:2},{sqlFilter:'held', icon:'pause', text:'Click to show all messages', nextKey:0}], subscribeButton: false, showSubscriptionModal: false, subscriptionId: null, subscriptionData: [], responseLoading: false, messagesLoading: false, queuesLoading: false, searchPage: null}
  }

  loadMessageQueues(selectedCategoryId=null, selectedQueueId=null)//, queryParametersAll=true)
  {
    this.setState({queuesLoading: true})
    //get message queues
    var selectedCategory
    invokeApig({path: "/messagequeues", method: "GET",  body: null}).then((result)=>
    {
      this.setState({messagequeuecategories: result.data.categories, allqueues: result.data.allqueues, messageQueuesLoaded: true} )
      if (selectedCategoryId)
      {
        for(var i=0;i<result.data.categories.length;i++)
        {
          if (result.data.categories[i].id===selectedCategoryId)
          {
            selectedCategory=result.data.categories[i]
            this.setState({selectedCategory: selectedCategory})
            break
          }
        }
        if (selectedCategory && selectedQueueId)
        {
          for(var i=0;i<selectedCategory.messagequeues.length;i++)
          {
            if (selectedCategory.messagequeues[i].id===selectedQueueId)
            {
              this.setState({selectedqueueid: selectedQueueId, selectedQueue: selectedCategory.messagequeues[i]})
              break
            }
          }
            
        }

      }
    });      
    // queryParametersAll if all then blank if not pass userid
    var queryParameters = this.state.assignedToMeFilter ? ['assigneduserid=' + this.props.user.id] : [];
    queryParameters.push('held=' +this.state.heldFilterData[this.state.heldFilter].sqlFilter);
    //get counts
    invokeApig({path: "/messagequeues/counts", method: "GET",  body: null, queryParams: queryParameters}).then((result)=>{
      this.setState({queueCounts: result.data.queuecounts, categoryCounts: result.data.categorycounts, messageQueuesLoaded: true} )});
  
    setTimeout(() => this.setState({ queuesLoading: false }), 5000);
  }

  async loadMessages(queueid, messageId=null, pageId=null)
  {
    this.setState({messages: [], columnHeaders: [], messagesLoading: true})
    if (pageId===null){pageId=1}
    //get message queues
    await invokeApig({path: "/messagequeues/"+queueid.toString() + "/messages", method: "GET", queryParams: ['pagenumber='+pageId, 'pagesize='+PAGE_SIZE]}).then((result)=>
    {
      this.setState({messages: result.data.messages, columnHeaders: result.data.columnheaders, responses: result.data.responses, messageSelected: false, validationFailed: false, holdButton: false, selectedMessage: {id: null, header: [], detail: []}} );
      
      for(var i=0; i<this.state.columnHeaders.length; i++){
        if(this.state.columnHeaders[i]==="Status") this.setState({holdButton: true, statusColumnId: i})
      }

      
      if (messageId)
      {
        var messagePageCheck=0
        for(var i=0;i<result.data.messages.length;i++)
        {
          if (i % 10===0){messagePageCheck++}
          if (result.data.messages[i].id===messageId)
          {
            this.setState({selectedMessage: result.data.messages[i], messageSelected: true, messagePage:messagePageCheck})
            
            break
          }
        }
      }
      if (pageId)
      { 
        var messagePage=pageId
        if (result.data.messages.length<=(pageId-1)*PAGE_SIZE)
        {
          messagePage=pageId-1;
        }
        this.setState({messagePage: messagePage})
      }
    });
    // load subscriptions      
    await invokeApig({path: "/messagequeues/"+queueid.toString() + "/subscriptions", method: "GET"}).then((result)=>
    {
      this.setState({subscriptionId: null,  subscriptionData: []})
      if (result.status===200)
      {
        if(result.data.length>0)
        {
        this.setState({subscriptionId: result.data[0].id, subscriptionData: result.data[0]});
        }
      }
    });
    this.setState({messagesLoading: false});
  }

  async postResponse(responsekey, data)
  {
    this.setState({responseLoading: true});
    const url= "/messages/"+this.state.selectedMessage.id + "/responses";
    await invokeApig({path: url, method: "POST",  body: {responsekey: responsekey, responsedata: data}}).then((result)=>
    {
      if (result.status===200)
      {
        //reload messages but keep current page
        this.loadMessages(this.state.selectedqueueid, null, this.state.messagePage)
      }
      else
      {
        this.setState({validationMessages: result.data, validationFailed: true} )
       }
       
    
    });
    this.setState({responseLoading: false});
  };

  assignMessage(userId, messageId=null)
  {
     const url= "/messages/"+this.state.selectedMessage.id 
     invokeApig({path: url, method: "PUT",  body: {assigneduserid: userId}}).then((result)=>
     {
       if (result.status===200)
       {
        //reload messages and message/comment tabs if message id passed
        this.loadMessages(this.state.selectedqueueid, this.state.selectedMessage.id, this.state.messagePage);
        this.setState({showAssignUser: false});
       }
       else
       {
        this.setState({validationMessages: result.data, validationFailed: true} )
       }
       
    
    });      
  }
  closeResponseModal()
  {
    this.setState({showResponseModal: false});
  }

  closeHoldModal()
  {
    this.setState({showHoldModal: false});
    // refresh the data to show changes
    this.loadMessages(this.state.selectedqueueid, this.state.selectedMessage.id)
  }

  closeSubscriptionModal()
  {
    this.setState({showSubscriptionModal: false});
    this.loadMessages(this.state.selectedqueueid, this.state.selectedMessage.id)
  }
  responseClick(response)
  {
    if('fields' in response)
    {
      if (response.fields.length>0)
      {
        //need to capture data first
        this.setState({selectedResponse: response, showResponseModal: true});
      }
      else
      {
        // no fields required - post response
        this.postResponse(response.key, {})
      }
    }
    else
    {
      // no fields required - post response
      this.postResponse(response.key, {})
    }
  }

  filterQueuesUser(){
    // change from user to all
    if(this.state.assignedToMeFilter){
      this.setState({assignedToMeFilter: false, assignedFilter: 'All'}, () => {this.loadMessageQueues()});
    } else{
    // change from all to user
    this.setState({assignedToMeFilter: true, assignedFilter: 'Me'}, () => {this.loadMessageQueues()})
    }
  //this.loadMessageQueues()
  }

  filterQueuesStatus=()=>{
    
    this.setState({heldFilter: this.state.heldFilterData[this.state.heldFilter].nextKey}, () => {this.loadMessageQueues()});

  }

  async componentDidMount() 
  { 
      if (this.props.user.functions.includes('messagesubscription'))
      {
        this.setState({subscribeButton: true});
      }
      const parseurl=this.props.location.pathname.split('/')
      if (parseurl.length>=3)
      {
        if (parseurl.length>=4)
        {
          this.loadMessageQueues(parseInt(parseurl[2]), parseInt(parseurl[3]))
          if (parseurl.length>=5)
          {
            this.loadMessages(parseInt(parseurl[3]), parseInt(parseurl[4]))
          }
          else
          {
            this.loadMessages(parseInt(parseurl[3]))
          }
  
        }
        else
        {
          this.loadMessageQueues(parseInt(parseurl[2]))

        }


      }
      else
      {
        this.loadMessageQueues(17)
      }
  }

  exportMessagesToExcel=()=>
  {
    
    invokeApig({path: "/messagequeues/"+this.state.selectedqueueid.toString() + "/messages", method: "GET", queryParams: ['pagenumber=1', 'pagesize=100000']}).then((result)=>
    {    
       const data=result.data.messages.map((message, i)=>{
        return message.header})
        var columnHeaders=this.state.columnHeaders;
      var today = new Date();
      var filename=this.state.selectedQueue.name.replace(/\//g, '-') + ' Messages '+ today.toISOString().substring(0, 10).replace(/-/g, '');
      var sheetname=this.state.selectedQueue.name.substring(0,30).replace(/\//g, '');
      exportToExcel(data, null, columnHeaders, filename+ '.xlsx', sheetname);
    }
    )


  }

  exportMessageQueuesToExcel=()=>
  {
    var columnHeaders=['Message Queue', 'Count'];
    const data=this.state.selectedCategory.messagequeues.map(queue=>{
      var count=0;
      if (queue.id in this.state.queueCounts){
        count=this.state.queueCounts[queue.id]
      }
      return [queue.name, count]})
    var today = new Date();
    var filename=this.state.selectedCategory.name ? this.state.selectedCategory.name : 'All';
    filename=filename+ ' Queues '+ today.toISOString().substring(0, 10).replace(/-/g, '');
    var sheetname=this.state.selectedCategory.name;

    exportToExcel(data, null, columnHeaders, filename+ '.xlsx', sheetname);
  }

  loadMessagesDetail(messageId){
    var changeWindow=true;
    if (this.state.responseLoading)
      changeWindow=window.confirm("Message response processing, are you sure you want to leave?");

    if (changeWindow)
    {
      invokeApig({path: "/messages/"+messageId.toString()+"/detail", method: "GET"}).then((result)=>
      {
        this.setState({selectedMessage: result.data.messages[0], messageSelected: true, responses: result.data.responses})
      });
    }
  }

  selectQueue(queueid=null, queue=null){
    
    var changeWindow=true;
    if (this.state.responseLoading)
      changeWindow=window.confirm("Message response processing, are you sure you want to leave?");

    if (changeWindow)
    {
      this.setState({selectedqueueid: queueid, selectedQueue: queue, searchPage: null});
      this.loadMessages(queue.id);
      this.props.history.push('/messages/'+this.state.selectedCategory.id + '/' + queue.id)
    }
  }

  selectPage() {
  
    const intPageNumber = parseInt(this.state.searchPage ? this.state.searchPage : 1);
    this.setState({messagePage: intPageNumber});
    this.loadMessages(this.state.selectedqueueid, null, intPageNumber);
  }

  renderPageInput=(searchPage, maxPage)=>{
    return <Input className="pageinput" size='mini' placeholder='Page...' type='number' min='1' max={maxPage} key={this.state.selectedqueueid} onChange={e =>{this.setState({searchPage: e.target.value})}} value={searchPage}/>
  }

  render() {

    const countlabel=(counts, id)=>{
      if (id in counts)
      {
        return <Label>{counts[id]}</Label>
      }
        
    }
  const renderline=(line, id)=>
  {
    if (line!==null)
    {
    if (line.constructor=== Array) 
    {
      if (line.length>0)
      {
        if (typeof line[0]==='string' || typeof line[0]==='number')
        {
          return <List bulleted>{line.map(item=>{return <List.Item>{JSON.stringify(item)}</List.Item>})}</List> 
        }
        else if (typeof line[0]==='object')
        {
          if ('detailarrayorder' in this.state.selectedQueue && this.state.selectedQueue.detailarrayorder.length >= id+1 && this.state.selectedQueue.detailarrayorder[id].length==Object.keys(line[0]).length) {
            const detailarrayorder = this.state.selectedQueue.detailarrayorder[id]
            var orderedlines=[]
            for (var eachline in line) {
              var orderedline={} 
              for (var item in detailarrayorder) {
                orderedline[detailarrayorder[item]] = line[eachline][detailarrayorder[item]]
              }
              orderedlines.push(orderedline)
            }

            return <Table compact collapsing>
              <Table.Header>
                <Table.Row>
                {Object.keys(orderedlines[0]).map(fieldname=>{return <Table.HeaderCell>{fieldname}</Table.HeaderCell>})}
                </Table.Row>
              </Table.Header>
                <Table.Body>
                {orderedlines.map(row=>{return <Table.Row>{Object.keys(row).map(fieldname=>{return <Table.Cell>{row[fieldname] ? row[fieldname].toString() : ''}</Table.Cell>})}</Table.Row>})}
                </Table.Body>
              </Table>            

          } else {

            return <Table compact collapsing>
              <Table.Header>
                <Table.Row>
                {Object.keys(line[0]).map(fieldname=>{return <Table.HeaderCell>{fieldname}</Table.HeaderCell>})}
                </Table.Row>
              </Table.Header>
                <Table.Body>
                {line.map(row=>{return <Table.Row>{Object.keys(row).map(fieldname=>{return <Table.Cell>{row[fieldname] ? row[fieldname].toString() : ''}</Table.Cell>})}</Table.Row>})}
                </Table.Body>
              </Table>            
          }
    
        }
      }
      
    }
    else if (typeof line === 'object')
    {
      if (line.type==='entity')
      {
        const url='/view/'+line.entity+'/'+line.entityinstanceid
        return <div><b><Link to={url} onClick={()=>{this.props.updateMessageIdFunction(this.state.selectedMessage.id, line.entity, line.entityinstanceid, this.state.selectedCategory.id, this.state.selectedQueue.id)}}>{line.entitydescription + ' ' + line.entityinstanceid}</Link></b><br/><br/></div> 
      }
      else if (line.type==='elecimportdataflow')
      {
        return <Popup on='click' trigger={<Button className='seaglasssecondarybutton'><Icon name='search'/>View Flow</Button>}><DataFlowViewer flowtype='elecimportdataflow' flowid={line.elecimportdataflowid}/></Popup>
      }
      else if (line.type==='gasimportdataflow')
      {
        return <Popup on='click' trigger={<Button className='seaglasssecondarybutton'><Icon name='search'/>View Flow</Button>}><DataFlowViewer flowtype='xoserveimportdataflow' flowid={line.gasimportdataflowid}/></Popup>
      }
      else if (line.type==='spaaimportdataflow')
      {
        return <Popup on='click' trigger={<Button className='seaglasssecondarybutton'><Icon name='search'/>View Flow</Button>}><DataFlowViewer flowtype='spaaimportdataflow' flowid={line.spaaimportdataflowid}/></Popup>
      }
      else if (line.type==='csseventdata')
      {
        return <Form><Form.Field><label>Event Data</label><ReactJson src={line.data} name={false} collapsed={true} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false}  theme={this.props.darkmode ? "summerfruit" : "summerfruit:inverted"}/></Form.Field></Form>
      }

      else {
        return <ReactJson src={line} name={false} collapsed={true} iconStyle="triangle" displayDataTypes={false} displayObjectSize={false} theme={this.props.darkmode ? "summerfruit" : "summerfruit:inverted"} />
      }

    }

    else if (typeof line === 'string')
    {
      return <p>{line}</p>
    }
  }
  }
  const onlyUnique=(value, index, self)=>{ 
    return self.indexOf(value) === index;
  }
  const assignedUsers=['All', 'Me', 'Someone', 'No-one'].concat(this.state.messages.map(message=>{return message.header[2]}).filter(name=>{return name!==''}).filter(onlyUnique).sort())
  const assignOptions=assignedUsers.map(name=>{return {key: name, text: name, value: name, content: name}})
  
  var messages;
  if (this.state.assignedFilter==='All')
    messages=this.state.messages;
  else if (this.state.assignedFilter==='Me')
    messages=this.state.messages.filter(message=>{return message.header[2]===this.props.user.firstname + ' '+this.props.user.lastname});
  else if (this.state.assignedFilter==='Someone')
    messages=this.state.messages.filter(message=>{return message.header[2]!==''});
  else if (this.state.assignedFilter==='No-one')
    messages=this.state.messages.filter(message=>{return message.header[2]===''});
  else
    messages=this.state.messages.filter(message=>{return message.header[2]===this.state.assignedFilter});

  // filter status
  if (this.state.holdButton){
    // held
    if (this.state.heldFilter==1) messages=messages.filter(message=>{return message.header[this.state.statusColumnId]===''});
    // workable
    if (this.state.heldFilter===2) messages=messages.filter(message=>{return message.header[this.state.statusColumnId]!==''});
    
  }
  
  const filteredMessageCount=messages.length;
  //handle pagination
  var messagePage=this.state.messagePage
  if (messages.length<(messagePage-1)*PAGE_SIZE)
  {
    messagePage=1;
    this.setState({messagePage: 1})
  }
  messages=messages.slice((messagePage-1)*PAGE_SIZE, messagePage*PAGE_SIZE)
    const messageview=<div>{this.state.selectedMessage.detail.map((line, id) =>{return renderline(line, id)})}</div>
    const messagepanes=[
        { menuItem: {key: 'Message', content: 'Message', icon: 'mail'}, render: () => <Tab.Pane>{messageview}</Tab.Pane> }, 
        { menuItem: {key: 'Comments', content: 'Comments', icon: 'talk'}, render: () => <Tab.Pane><Comments entityname='message' entityinstanceid={this.state.selectedMessage.id} userid={this.props.user.id} editCommunication={this.props.editCommunication}/></Tab.Pane> },
        { menuItem: {key: 'History', content: 'Message History', icon: 'history'}, render: () => <Tab.Pane><MessageHistory messageid={this.state.selectedMessage.id} userid={this.props.user.id}>Coming Soon</MessageHistory></Tab.Pane> }
    ]
    // how many tabs to show
    var messagepaneslice=this.state.holdButton ? 3 : 2;
    var held=this.state.selectedMessage.header[this.state.statusColumnId];
    
    return (
      <Grid className='fullpage' divided stretched>
      <Grid.Row className="main" stretched>
        <Grid.Column width={3} stretched>
        <Menu fluid className={this.props.darkmode ? "seaglassblueinverted-darkmode" : "seaglassblueinverted"} inverted vertical>
        <Menu.Item  className="menuheader" header>Queues
          <Button compact size='mini' icon='file excel outline' floated='right' onClick={()=>{this.exportMessageQueuesToExcel()}}/>
        </Menu.Item>
        <Menu.Item><Input className='mini' icon='search' placeholder='Search...' onChange={(event, data)=>{this.setState({queueSearch: data.value})}}/></Menu.Item>
        {this.state.selectedCategory.messagequeues.filter(queue=>{return this.state.queueSearch==='' || queue.name.toLowerCase().includes(this.state.queueSearch.toLowerCase())}).map(queue=><Menu.Item className="seaglassblueinvertedmenu" active={queue.id===this.state.selectedqueueid} onClick={()=>{this.selectQueue(queue.id, queue)}}>{queue.name}{countlabel(this.state.queueCounts, queue.id)}</Menu.Item>)}      
        </Menu>
        </Grid.Column>
        <Grid.Column width={10} stretched>
        <Grid>
        <Grid.Row className="detail">
        
        {this.state.selectedqueueid && <Segment className="messagelist">
        <Segment clearing className="messagelistheader">
          <Header  as='h4' floated='left'>
            <Icon name='mail'/>{' '}{this.state.selectedQueue.name + ' '}
          </Header>
          {this.state.subscribeButton ?
          <Header as='h4' floated='right'>
          <Popup content={this.state.subscriptionId ? 'Edit subscription' : 'Set up subscription'} trigger={<Button icon='bell' className='seaglassblue' onClick={()=>{this.setState({showSubscriptionModal: true})}}/>}/>
          </Header> : null}
        </Segment>
        <SubscriptionModal visible={this.state.showSubscriptionModal} functionName="messagesubscription" parententity="message" closefunctionmodal={this.closeSubscriptionModal} parententityid={this.state.selectedqueueid} parameters={{parententityid: this.state.selectedqueueid}} subscriptionData={this.state.subscriptionData} subscriptionId={this.state.subscriptionId}/>
        <div class="messagelistscroll">
        {this.state.messagesLoading ? 
          this.props.darkmode ? <Dimmer active> <Loader size='massive' content='Loading Messages' /> </Dimmer> 
          : <Dimmer active inverted> <Loader size='massive' content='Loading Messages' /> </Dimmer>
        : null}
          <Table selectable compact >
            <Table.Header>
              <Table.Row>
                {this.state.columnHeaders.map((header, i)=>{
                  return <Table.HeaderCell>
                  {header + ' '}
                  {i===2 && <Dropdown inline onChange={(event, data)=>{this.setState({assignedFilter: data.value})}} options={assignOptions} defaultValue={assignOptions[0].value}/>}
                  </Table.HeaderCell>})}
              </Table.Row>  
            </Table.Header>
            <Table.Body>
            {messages.map((message, i) =>
              <Table.Row key={i} active={message.id===this.state.selectedMessage.id} onClick={(cell)=>{this.setState({messageSelected: true, validationFailed: false}); this.loadMessagesDetail(message.id); this.props.history.push('/messages/'+this.state.selectedCategory.id + '/' + this.state.selectedqueueid+ '/' + message.id)}}>
              {message.header.map((headervalue, j)=><Table.Cell key={j}>{j===1 ? formatDateTime(new Date(headervalue)) : headervalue}</Table.Cell>)}
              </Table.Row>)}
            </Table.Body>

          </Table>
          </div>
          <Divider hidden fitted/> 
          <Pagination  style={{color: this.props.darkmode ? "white": "black"}} activePage={this.state.messagePage} defaultActivePage={1} totalPages={Math.ceil(filteredMessageCount/PAGE_SIZE)} onPageChange={(event, { activePage })=>{this.setState({messagePage: activePage}); this.loadMessages(this.state.selectedqueueid, null, activePage)}}/> 
          <Button floated='right' className='seaglasssecondarybutton' onClick={this.exportMessagesToExcel}><Icon name='file excel outline'/>Export</Button>
          {this.renderPageInput(this.state.searchPage, Math.ceil(filteredMessageCount/PAGE_SIZE))}
          <Button icon className='seaglasssecondarybutton' onClick={(cell)=>{this.selectPage()}}><Icon name='arrow right'/></Button>
          </Segment>
          }
        </Grid.Row>                    
        <Grid.Row className="detail">
          {this.state.messageSelected ?
          <Segment className="messagedetail">
          {/* <Menu> */}
          {/* <Menu.Item header>Response</Menu.Item> */}
          {this.state.responses.map(response=>{return <Button className="seaglasssecondarybutton" onClick={()=>{this.responseClick(response)}}><Icon name={response.icon}/>{response.text}</Button>})}
            {this.state.holdButton ? <Button className="seaglasssecondarybutton" onClick={()=>{this.setState({showHoldModal: true})}}><Icon name={held? 'play' : 'pause'}/>{held? 'Release' : 'Set to Held'}</Button> : null}
            <Button className="seaglasssecondarybutton" disabled={this.state.selectedMessage.header[2]!==''} onClick={()=>{this.setState({showAssignUser: true})}}><Icon name='share'/>Assign</Button>
            <Button className="seaglasssecondarybutton" disabled={this.state.selectedMessage.header[2]!==''} onClick={()=>{this.assignMessage(this.props.user.id, this.state.selectedMessage.id)}}><Icon name='share'/><Icon name='user'/>Assign To Me</Button>
            <Button className="seaglasssecondarybutton" disabled={this.state.selectedMessage.header[2]===''} onClick={()=>{this.assignMessage(null)}}><Icon name='cancel'/>De-Assign</Button>
          {this.state.responseLoading ? 
            this.props.darkmode ? <Dimmer active> <Loader size='massive' content='Processing Message Response' /> </Dimmer> 
            : <Dimmer active inverted> <Loader size='massive' content='Processing Message Response' /> </Dimmer>
          : null}
        <Message
        error
        hidden={!this.state.validationFailed}
        header="Message response failed"
        list={this.state.validationMessages}
        />
        <Tab menu={{secondary: true, pointing: true}} panes={messagepanes.slice(0, messagepaneslice)} />
        {this.state.showResponseModal ? 
        <MessageResponseModal visible={this.state.showResponseModal} messageid={this.state.selectedMessage.id} response={this.state.selectedResponse} postresponse={this.postResponse} closeresponsemodal={this.closeResponseModal} size={'size' in this.state.selectedResponse ? this.state.selectedResponse.size : 'small'} />
        :
        null}
        {this.state.showHoldModal ?
        <FunctionModal visible={this.state.showHoldModal} functionName={held ? "releasemessage" : "holdmessage"} parententity="message" closefunctionmodal={this.closeHoldModal} parententityid={this.state.selectedMessage.id} parameters={{parententityid: this.state.selectedMessage.id}}/>
        :
        null}
        <Modal open={this.state.showAssignUser}>
        <Modal.Header size='tiny'>
          <h3><Icon circular color="seaglassblue" name='mail forward'/>Assign Message</h3>
        </Modal.Header>  
        <Modal.Content>
        <Form>
        <Form.Field>
        <label>User</label>
        <UserSearch onSelect={userid=>{this.setState({assignUserId: userid})}}/>    
        </Form.Field>
        <Button className="seaglasssecondarybutton" disabled={!this.state.assignUserId} onClick={()=>{this.assignMessage(this.state.assignUserId)}} primary>Assign</Button>
        <Button className="seaglasssecondarybutton" onClick={()=>{this.setState({showAssignUser: false})}} >Close</Button>
        </Form>
        </Modal.Content>
 
        </Modal>  
          </Segment>
          :
          ''}
        </Grid.Row>                    
        </Grid>   
        </Grid.Column>
        </Grid.Row>
       </Grid>
       

    );
  }
}